import { reducerTypes } from "./types";

export const setSelectedCurrencyAction = (data: string) => ({
    type: reducerTypes.SET_SELECTED_CURRENCY,
    payload: data,
});


export const getCurrenciesAction = (data: string[]) => ({
    type: reducerTypes.GET_CURRENCIES,
    payload: data,
});

export const getCurrencyRateAction = (data: number) => ({
    type: reducerTypes.GET_CURRENCY_RATE,
    payload: data,
});
